import { type OpportunitySearch } from "@repo/api";
import { Button, Text, checkmarkIcon, copyIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import { Line, ModalSheet, SectionContainer, useSettings } from "@repo/ui";
import { type MouseEvent, useState } from "react";
import { useNavigate } from "react-router-dom";

interface GeneratedProjectDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  project?: OpportunitySearch;
}
export const GeneratedProjectDetailModal = ({
  isOpen,
  onClose,
  project,
}: GeneratedProjectDetailModalProps) => {
  const navigate = useNavigate();
  const { language } = useSettings();
  const [copied, setCopied] = useState(false);

  const onCopyText = async (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    await navigator.clipboard.writeText(
      project?.followupSummary?.talkingPoint[language] || ""
    );
    setCopied(true);
  };

  const onCloseModal = () => {
    setCopied(false);
    onClose();
  };

  if (!project) {
    return null;
  }

  return (
    <ModalSheet
      visible={isOpen}
      title={project?.title}
      onClose={onCloseModal}
      footer={
        <Button
          text={t("action.open_project")}
          type="primary"
          onClick={() => navigate(`/opportunity/${project.opportunityId}`)}
        />
      }
    >
      <SectionContainer>
        <Text textStyle="Heading.S">{t("label.ai_overview")}</Text>
        <Text textStyle="Body.M">
          {project.followupSummary?.insight[language]}
        </Text>
        <Line />
        <Text textStyle="Heading.XS">{t("label.recommended_action")}</Text>
        <Text textStyle="Body.M">
          {project.followupSummary?.action[language]}
        </Text>
        <Line />
        <Text textStyle="Heading.XS">{t("label.talking_point")}</Text>
        <Text textStyle="Body.M">
          {project.followupSummary?.talkingPoint[language]}
        </Text>
        <div>
          <Button
            ssrIcon={copied ? checkmarkIcon : copyIcon}
            text={
              copied
                ? t("prompt.copied_to_clipboard")
                : t("action.copy_to_clipboard")
            }
            type="secondary"
            size="small"
            disabled={!project.followupSummary?.talkingPoint}
            onClick={onCopyText}
          />
        </div>
      </SectionContainer>
    </ModalSheet>
  );
};
